import { cookie } from '@pdrj/pmi-iqos-shared-react'

export default class IqosphereQuest {
  constructor(api) {
    this.api = api
  }

  validateQuest = async dataToValidate => {
    return await this.api.post('/iqosphere/quest/validate', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getQuestValidation'),
      data: dataToValidate
    })
  }

  submitQuest = async (questData, questId) => {
    return await this.api.post('/iqosphere/quest?rpc=true', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getQuestSubmit'),
      useProxy: true,
      withCredentials: true,
      data: {
        ...questData,
        id: questId
      }
    })
  }

  getQuest = async questId => {
    return await this.api.get('/iqosphere/quest/' + questId, {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getQuest')
    })
  }

  getQuestDetail = async questId => {
    return await this.api.get('/iqosphere/quest/' + questId + '/detail', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getQuestDetail')
    })
  }

  getQuestList = async () => {
    return await this.api.get('/iqosphere/quest', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getQuestList')
    })
  }

  deleteQuestNotice = async () => {
    return await this.api.delete('/iqosphere/quest/track', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getQuestValidation')
    })
  }
}
